import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { Router } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { MustMatch } from '../../service/must-match.service';
import { ApiUrls } from '../../apiRouts';
import { LocalStorageService } from '../../service/local-storage.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  passwordForm: any = FormGroup;
  setPasswordFlag: boolean = false;
  showPassword: boolean = false;
  confirmPassword: boolean = false;
  passwordSubmitted = false;
  oldPasswordFlag: boolean = false;
  userId: any;
  userPassword: any;
  constructor(private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private router: Router,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.userPassword = JSON.parse(this.localStorageService.getItem("loginData") || '{}').password
    this.passwordForm = this.fb.group({
      oldPassword: ['', [Validators.required]],
      password: ['', [Validators.required]],
      cpassword: ['', [Validators.required]]
    }, {
      validator: MustMatch('password', 'cpassword')
    });
  }
  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.passwordForm.controls;
  }

  oldPassword() {
    this.oldPasswordFlag = !this.oldPasswordFlag;
  }

  password() {
    this.showPassword = !this.showPassword
  }

  confirmPwd() {
    this.confirmPassword = !this.confirmPassword
  }

  changePassword() {
    this.passwordSubmitted = true;

    if (this.passwordForm.valid) {
      if (this.passwordForm.value.oldPassword == this.userPassword) {
        let data = {
          user_id: Number(this.userId),
          name: "",
          address: "",
          contact_no: '',
          whatsapp_no: "",
          business: "",
          office_contact: "",
          office_address: "",
          village_id: 0,
          current_city_id: 0,
          education: "",
          dob: "",
          blood_group: "",
          image: "", // Assigning an empty string for image
          image_file: [], // Assigning an empty array for image_file
          relation_id: 0,
          main_member_id: 0,
          maternal_name: "",
          maternal_village_id: 0,
          is_verified: 0,
          user_type_id: 0,
          password: this.passwordForm.value.cpassword,
          created_by: 0,
          fcm_token: '',
          Action: 'CHANGEPASSWORD',

        };
        this.mainService.postApi(ApiUrls.userSignUp, data, 1).subscribe((res: any) => {
          if (res.status === 1) {
            if (res.user.length > 0) {
              this.toasterService.toastSuccess(res.response);
              this.router.navigate(['/auth/login']);
            } else {
              this.toasterService.toastError(res.response);
            }
          } else {
            this.toasterService.toastError(res.response);
          }
        });
        this.passwordForm.reset();
        this.passwordSubmitted = false;
      } else {
        this.passwordSubmitted = true;
        this.toasterService.toastError('તમે દાખલ કરેલ વર્તમાન પાસવર્ડ માન્ય નથી');
      }
    }
  }
}
